
import PinInput from '~/components/modal/cart/PinInput.vue';
import CreditCardForm from '~/components/modal/cart/CreditCardForm.vue';
import PayPalForm from '~/components/modal/cart/PayPalForm.vue';
import CartSummary from '~/components/modal/cart/CartSummary.vue';


export default {
	components: {
		PinInput,
		CreditCardForm,
		PayPalForm,
		CartSummary
	},
	data() {
		return {
			hideAll: true,
			showTooltip: false,
			selectedPaymentMethod: 'credit-card',
			cart: {
				items: [],
				summary: {
					subtotal: { value: 0 },
					total: { value: 0 },
				},
			},
			orderId: '123456', // Placeholder for the order ID
			successMessage: "Success", // Placeholder for the success message
			memberUsername: null, // Placeholder for the member username
			isProcessing: false,  // Tracks if the checkout is in progress
			checkoutSuccess: false,  // Tracks if the checkout was successful
			showCardForm: true, // Toggle credit card form visibility
			nonce: null, // Placeholder for the payment nonce
			isPinValidated: false, // Flag to indicate if PIN is validated
			isPinResending: false,
			showThankYouMessage: false, // Flag to show the thank you message
			pinResendSuccess: false,
			showPinInput: false, // Flag to toggle PIN input visibility
			pinFormKey: 0, // authorization key for the PIN form
			pinDigits: Array(5).fill(''), // Array to hold 5 PIN digits
			isPasswordValid: false, // Tracks if the password is strong
			passwordsMatch: false, // Tracks if passwords match
			randomPhrase: '', // Placeholder for random phrases
			isValidEmail: false, // Tracks if the email is valid,
			selectedPaymentMethod: null,
			phrases: [
				"Tuning the strings...",
				"Checking fretboard alignment...",
				"Polishing the guitar body...",
				"Adjusting the truss rod...",
				"Stretching new strings...",
				"Testing amplifier connection...",
				"Setting intonation..."
			],
			errors: {},
			discounts: [
				{ name: 'Promo Code ABC', amount: 5.0 },
				{ name: 'Loyalty Discount', amount: 10.0 },
			],
			tfUrl: this.$config.TrueFireUrl || 'https://truefire.com'
		};
	},
	props: {
		itemids: {
			type: Array,
			required: true
		},
		formData: {
			type: Object,
			required: true
		},
		enableValidation: {
			type: Boolean,
			default: false
		},
		paymentMethod: {
			type: String,
			default: null
		},
		cardType: {
			type: String,
			default: null
		},
		availablePaymentMethods: {
			type: Array,
			default: () => ['credit-card'], // Default to only credit-card
			validator: function (value) {
				// Validate that only allowed payment methods are provided
				const allowedMethods = ['credit-card', 'paypal'];
				return value.every(method => allowedMethods.includes(method));
			}
		}
	},
	computed: {
		// Computed property to monitor the auth_token cookie
		authToken() {
			return this.$cookies.get('auth_token');
		},
		calculateDiscount() {
			let discounts = [];
			this.discounts = [];
			//loop through all this.cart.summary
			//if the key has the string discount in it add to the discounts array
			for (const [key, value] of Object.entries(this.cart.summary)) {
				if (key.includes('discount')) {
					this.discounts.push({
						name: value.title,
						amount: value.value
					})
					discounts.push(value.value);
				}
			}
			//return the sum of all discounts in the discounts array
			return discounts.reduce((total, discount) => total + discount, 0);

		},
		discountTooltip() {
			return this.discounts
				.map((discount) => `${discount.name}: -${this.$options.filters.currency(discount.amount)}`)
				.join('\n');
		},
	},
	async mounted() {
		this.startProcessing(); // Start the processing spinner
		const cart = await this.$member.cart.setItems(this.itemids); // Set the cart items
		this.cart = cart.data.member.cart.cart ?? cart.data.member.cart; // Update the cart data
		await this.checkAuthToken(); // Check the token on component mount
		//if the email is in the query string and we do not have a logged in user prefill the email form
		if (!this.memberUsername) { // Only proceed if user is not logged in
			if (this.$route.query.email) {
				this.formData.email = this.$route.query.email;
				await this.checkEmailAddressForExistingMember(); // Check email after setting it
			} else {
				// Get temporary email from store
				const tempEmail = localStorage.getItem('tmp_email');
				console.log('tmp_email:', tempEmail);
				if (tempEmail) {
					this.formData.email = tempEmail;
					//regex test email then set valid
					const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
					if (emailRegex.test(tempEmail)) {
						this.isValidEmail = true;
						await this.checkEmailAddressForExistingMember(); // Check email after validating it
					}
				}
			}
		}
		this.stopProcessing(); // Stop the processing spinner
	},
	methods: {
		cancelPinInput() {
			this.showPinInput = false
		},
		isPaymentMethodAvailable(method) {
			return this.availablePaymentMethods.includes(method);
		},
		selectPaymentMethod(method) {
			this.selectedPaymentMethod = method;
			this.nonce = null; // Reset payment nonce
			this.errors.general = null; // Clear general errors
		},
		initializePaymentMethod() {
			// If only one payment method is available, select it automatically
			if (this.availablePaymentMethods.length === 1) {
				this.selectPaymentMethod(this.availablePaymentMethods[0]);
			} else if (this.availablePaymentMethods.length > 1 && !this.selectedPaymentMethod) {
				// If multiple methods are available and none is selected, default to the first one
				this.selectPaymentMethod(this.availablePaymentMethods[0]);
			}
		},
		async handlePinEntered(pin) {
			try {
				const response = await this.$member.auth.validateEmailWithPinAndKey(
					this.formData.email,
					pin,
					this.pinFormKey
				);

				this.memberUsername = response.data.member.memberusername;
				this.errors.pin = null;
				this.isPinValidated = true;
				this.showPinInput = false;

				// Check member status after successful PIN validation
				const member_status = await this.$member.get('tfu_status');
				if (member_status === 'master') {
					this.showThankYouMessage = true;
					// Wait 3 seconds before closing
					// setTimeout(() => {
					// 	this.onCloseModal();
					// }, 3000);
				}
			} catch (error) {
				this.errors.pin = "Invalid Pin. Please try again.";
				// Reset the PIN input component
				this.$refs.pinInput.reset();
			}
		},
		handlePinError(error) {
			this.errors.pin = error;
		},
		handleInvalidKey() {
			this.pinFormKey = 0;
			this.showPinInput = false;
		},
		useCard() {
			this.showCardForm = true; // Show the CreditCardForm
		},
		async onCloseModal() {
			// Emit reload-content first
			this.$emit('reload-content');
			// Then close the modal
			this.$emit('close-modal');
		},
		startProcessing() {
			this.isProcessing = true;
			this.updateRandomPhrase(); // Initialize random phrase updates
		},
		updateRandomPhrase() {
			this.randomPhrase = this.phrases[Math.floor(Math.random() * this.phrases.length)];
			if (this.isProcessing) {
				setTimeout(this.updateRandomPhrase, 2000); // Update the phrase every 2 seconds
			}
		},
		stopProcessing() {
			this.isProcessing = false;
		},
		storeNonce(nonce) {
			this.nonce = nonce; // Save the nonce for later checkout
			this.showCardForm = false; // Hide the CreditCardForm
		},
		async checkout() {
			// Validate email presence if memberUsername is not available
			if (!this.formData.email && !this.memberUsername) {
				this.errors.email = 'Email address is required.';
				// Focus on the email field to guide the user
				this.$refs['emailInput'].focus();
				return;
			} else {
				this.errors.email = null; // Clear error if email is present
			}

			if (!this.memberUsername) {
				if (this.passwordsMatch == false) {
					this.errors.password = 'Passwords do not match.';
					this.$refs['passwordInput'].focus();
					return;
				}
				if (this.strongPassword == false) {
					this.errors.password = 'Password is required.';
					this.$refs['passwordInput'].focus();
					return;
				}
			}

			if (this.selectedPaymentMethod === 'credit-card' && !this.nonce) {
				this.errors.general = 'Payment information is missing.';
				return;
			}

			try {
				this.startProcessing(); // Start the processing spinner

				// If the user is not a member, register them
				if (!this.memberUsername) {
					await this.$member.auth.register({
						email: this.formData.email,
						password: this.formData.password,
						bypass_trial: true,
						send_redirect: false,
					});
					this.memberUsername = await this.$member.get('memberusername');
				}

				// Simulate API call for the checkout process
				const payload = {
					email: this.formData.email ?? null,
					password: this.formData.password ?? null,
					payment: {
						cc: {
							opaqueData: this.nonce,
						},
					},
				};

				const response = await this.$member.cart.checkout(payload);

				if (response.status === 200) {
					return response.data;
				} else {
					throw new Error(response.data?.message || 'An error occurred during checkout.');
				}
			} catch (error) {
				console.error('Checkout failed:', error);

				this.errors.general = error.response?.data?.message || 'An unexpected error occurred.';
				throw error;
			} finally {
				this.stopProcessing(); // Stop the spinner
			}
		},
		closeModal() {
			this.$emit('close-modal');
		},
		selectPaymentMethod(method) {
			this.selectedPaymentMethod = method;
			this.nonce = null; // Reset payment nonce
			this.errors.general = null; // Clear general errors
		},
		async submitCheckoutWithCreditCard(nonce) {
			this.nonce = nonce;
			this.startProcessing();
			try {
				const checkoutResponse = await this.checkout();
				console.log('Checkout response:', checkoutResponse);
				this.orderId = checkoutResponse.member.order.id;
				this.stopProcessing();
				this.checkoutSuccess = true;
			} catch (error) {
				console.error('Checkout failed:', error);
				this.stopProcessing();
				this.errors.general = error.response?.data?.message || 'An error occurred during checkout.';
			}
		},
		async submitCheckoutWithPayPal(billingAgreementId) {
			this.startProcessing();
			try {
				const checkoutResponse = await this.$member.cart.checkout({
					email: this.formData.email ?? null,
					password: this.formData.password ?? null,
					payment: {
						paypal: {
							billing_agreement_id: billingAgreementId
						}
					}
				});

				this.orderId = checkoutResponse.member.order.id;
				this.stopProcessing();
				this.checkoutSuccess = true;
			} catch (error) {
				console.error('Checkout failed:', error);
				this.stopProcessing();
				this.errors.general = error.response?.data?.message || 'An error occurred during checkout';
			}
		},
		async checkEmailAddressForExistingMember() {
			let email = this.formData.email;

			//validate the email pattern
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/u; // Add `u` for Unicode support
			if (!emailRegex.test(email)) {
				this.errors.email = 'Invalid email address.';
				this.isValidEmail = false;
				return;
			} else {
				this.isValidEmail = true;
				this.errors.email = null;
			}

			if (!email) return;
			let checkEmail = await this.$member.auth.checkForExistingEmail(email);
			console.log('checkEmail:', checkEmail);
			if (checkEmail.status == 200) {
				let emailCheckData = checkEmail.data.member;
				//PIN sent
				if (emailCheckData.sent_pin) {
					this.pinFormKey = emailCheckData.sent_pin.key;
					this.showPinInput = true;
					this.$nextTick(() => {
						const firstInput = this.$refs['pinInput0'];
						if (firstInput && firstInput[0]) {
							firstInput[0].focus();
						}
					});
				} else {
					this.showPinInput = false;
					if (emailCheckData.auth_token) {
						const memberusername = await this.$member.get('memberusername');
						const member_status = await this.$member.get('tfu_status');
						if (member_status == 'master') {
							this.showThankYouMessage = true;
							// this.onCloseModal();
						}
						if (memberusername) {
							this.memberUsername = memberusername;
						}
					}
				}
			}
		},
		resetPasswordValidation() {
			this.isPasswordValid = false; // Reset validation when the password is modified
			this.passwordsMatch = false;
			this.formData.confirmPassword = ''; // Clear confirm password
		},
		validatePassword() {
			const password = this.formData.password;
			const confirmPassword = this.formData.confirmPassword;

			// Validate password strength
			const strongPasswordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
			this.isPasswordValid = strongPasswordRegex.test(password);

			if (!this.isPasswordValid) {
				this.errors.password =
					'Password must be at least 8 characters long and include a letter, a number, and a special character.';
				return;
			}

			this.errors.password = null; // Clear password error if valid

			// Check if passwords match
			this.passwordsMatch = password === confirmPassword;

			if (!this.passwordsMatch && confirmPassword.length > 0) {
				this.errors.password = null; // Ensure no error for matching logic
			}
		},
		async checkAuthToken() {
			const authToken = this.authToken; // Access the computed property
			if (authToken) {
				console.log('auth_token found, attempting to fetch member...');
				try {
					const member = await this.$member.get('memberusername');
					const member_status = await this.$member.get('tfu_status');
					if (typeof member === 'string' && member.trim() !== '') {
						this.memberUsername = member.trim(); // Update the memberUsername
					} else {
						this.memberUsername = null; // Clear if invalid
					}
					if (member_status == 'master') {
						this.showThankYouMessage = true;
					}
					console.log('Fetched member:', this.memberUsername);
				} catch (error) {
					console.error('Failed to fetch member:', error);
					this.memberUsername = null;
				}
			} else {
				this.memberUsername = null; // Clear if no token is found
			}
		},
		async logout() {
			this.$member.auth.logout();
			this.memberUsername = null; // Clear the member username
			//clear all formData
			this.formData.email = "";
			this.formData.username = "";
			this.formData.password = "";
			this.formData.confirmPassword = "";
			this.errors = {};
			this.$emit('reload-content');
			this.$emit('close-modal');
		},
	},
	filters: {
		currency(value) {
			return `$${value.toFixed(2)}`;
		}
	},
	watch: {
		// Watch for changes to the email field
		'formData.email': function (newValue, oldValue) {
			if (newValue !== oldValue) {
				this.isPinValidated = false; // Reset the success state when email is modified
			}
		},
		authToken(newToken, oldToken) {
			console.log('auth_token changed:', { newToken, oldToken });
			this.checkAuthToken(); // Revalidate the member data
		},
		availablePaymentMethods: {
			immediate: true,
			handler() {
				this.initializePaymentMethod();
			}
		},
		memberUsername(newVal) {
			if (newVal) {
				this.initializePaymentMethod();
			}
		}
	},
};
